import { localDateOf } from "@/lib/body-measurements";

/**
 * Whether `date` (YYYY-MM-DD) is after today. Måltider and Magesmerter log
 * what has already happened — food eaten, pain felt — so a day still ahead
 * has nothing to log, and an entry made there by mistake would sit outside
 * any report period ending today.
 */
export function isFutureDate(date: string): boolean {
  return date > localDateOf(new Date());
}

/** The card a logging kind shows on a day that has not happened yet. */
export function FutureDayCard({
  configId,
  label,
  kindClass,
}: {
  configId: string;
  label: string;
  kindClass: string;
}) {
  return (
    <section
      className={`widget-card ${kindClass} future-day`}
      data-testid={`widget-day-${configId}`}
      data-logging-completed="false"
    >
      <header className="widget-card-head">
        <h3 className="widget-card-title">{label}</h3>
      </header>
      <div className="widget-card-body">
        <p className="hint" data-testid={`future-day-hint-${configId}`}>
          Du kan ikke logge en dag som ikke har vært ennå.
        </p>
      </div>
    </section>
  );
}
